<span [ngClass]="'text-' + termwebMessageType">{{ termwebMessage }}</span>
